import { BillRepository } from "../../repositories/BillRepository";
import { BillCountsEntity } from "../../entities/BillEntity";

/**
 * Get Bill Counts Use Case
 * Retrieves counts for all bill categories for dashboard cards
 */
export class GetBillCountsUseCase {
  constructor(private repository: BillRepository) {}

  async execute(params?: {
    date_from?: string;
    date_to?: string;
  }): Promise<BillCountsEntity> {
    return await this.repository.fetchBillCounts(params);
  }
}

